import React from 'react'
import { FormattedMessage } from 'react-intl'
import { useOrganization } from 'contexts/organization'
import { usePayment } from 'contexts/payment'
import { Section, Heading, IconMessage } from '../s'
import Paragraph from 'components/typography/paragraph'
import { OrderedList, ListItem } from 'components/list'
import {
    CheckCircleFilled as Success,
    InfoCircleFilled as Info
} from 'components/feather'
import { Lightbulb as Idea } from 'styled-icons/material-outlined'

const TeamtailorSupportedFeatures = () => {
    const { organization } = useOrganization()
    const { account } = usePayment()

    const showPriceIncreaseWarning = !!organization?.userCount && !!account?.subscription?.chargePlan?.mainCharge?.quantity

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_heading_supported_features"
                    defaultMessage="Supported features" />
            </Heading>
            <OrderedList>
                <ListItem>
                    <IconMessage className="success">
                        <Success size={20} />
                        <div>
                            <Paragraph>
                                <strong>
                                    <FormattedMessage
                                        id="integration_teamtailor_feature_heading_send_new_hire"
                                        defaultMessage="Send the new hire to Huma" />
                                </strong>
                                <br />
                                <FormattedMessage
                                    id="integration_teamtailor_feature_text_send_new_hire"
                                    defaultMessage="The candidate is automatically sent to Huma via a trigger that you add to a stage in the recruitment process." />
                            </Paragraph>
                            {showPriceIncreaseWarning && (
                                <OrderedList>
                                    <ListItem>
                                        <IconMessage className="info">
                                            <Info size={20} />
                                            <Paragraph>
                                                <FormattedMessage
                                                    id="payment_integration_remote_user_creation_price_increase_warning"
                                                    defaultMessage="When externally triggered user creation causes the number of active users to exceed the number of billed seats, you will get a cost increase on your subscription that will last until end of term." />
                                            </Paragraph>
                                        </IconMessage>
                                    </ListItem>
                                </OrderedList>
                            )}
                        </div>
                    </IconMessage>
                </ListItem>
                <ListItem>
                    <IconMessage className="success">
                        <Success size={20} />
                        <div>
                            <Paragraph>
                                <strong>
                                    <FormattedMessage
                                        id="integration_teamtailor_feature_heading_team_location"
                                        defaultMessage="Add new hires automatically to a team and/or location" />
                                </strong>
                                <br />
                                <FormattedMessage
                                    id="integration_teamtailor_feature_text_team_location"
                                    defaultMessage="When setting up the trigger in Teamtailor, you can choose which team and location the new hire will be a member of." />
                            </Paragraph>
                            <OrderedList>
                                <ListItem>
                                    <IconMessage className="idea">
                                        <Idea size={20} />
                                        <Paragraph>
                                            <FormattedMessage
                                                id="integration_teamtailor_feature_note_team_location"
                                                defaultMessage="Gather your new hires in one place by creating a team in Huma and set it up in the trigger." />
                                        </Paragraph>
                                    </IconMessage>
                                </ListItem>
                            </OrderedList>
                        </div>
                    </IconMessage>
                </ListItem>
                <ListItem>
                    <IconMessage className="success">
                        <Success size={20} />
                        <div>
                            <Paragraph>
                                <strong>
                                    <FormattedMessage
                                        id="integration_teamtailor_feature_heading_assign_supervisor"
                                        defaultMessage="Assign a supervisor" />
                                </strong>
                                <br />
                                <FormattedMessage
                                    id="integration_teamtailor_feature_text_assign_supervisor"
                                    defaultMessage="When setting up the trigger in Teamtailor, you can choose who will be the new hire’s supervisor." />
                            </Paragraph>
                        </div>
                    </IconMessage>
                </ListItem>


                <ListItem>
                    <IconMessage className="success">
                        <Success size={20} />
                        <div>
                            <Paragraph>
                                <strong>
                                    <FormattedMessage
                                        id="integration_teamtailor_feature_heading_automatic_user_creation_other_integrations"
                                        defaultMessage="Creation of users in other integrations" />
                                </strong>
                                <br />
                                <FormattedMessage
                                    id="integration_teamtailor_feature_text_automatic_user_creation_other_integrations"
                                    defaultMessage="Users created by the Teamtailor integration will be created automatically in other integrated systems that supports it and where you have enabled it. To create users in other integrations, they have to be manually resynchronized." />
                            </Paragraph>
                        </div>
                    </IconMessage>
                </ListItem>


            </OrderedList>
        </Section>
    )
}

export default TeamtailorSupportedFeatures